import { render, staticRenderFns } from "./AdminCatalog.vue?vue&type=template&id=b4156e94&"
import script from "./AdminCatalog.vue?vue&type=script&lang=js&"
export * from "./AdminCatalog.vue?vue&type=script&lang=js&"
import style0 from "./AdminCatalog.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports